import axios from 'axios'

class DocumentosSolicitadosApiClient {

    async buscar(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/documentos-solicitados`)
    }

    async adicionar(compraDiretaId, documentoId) {
        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/documentos-solicitados`, {documentoId})
    }

    async adicionarDocumentoSemVinculo(documento) {
        return await axios.post('/compra-direta/api/v1/comprador/documentos', documento)
    }

    async excluir(compraDiretaId, documentoSolicitadoId) {
        return await axios.delete(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/documentos-solicitados/${documentoSolicitadoId}`)
    }

}

export default new DocumentosSolicitadosApiClient()
